import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Markets from "@/pages/Markets";
import MarketDetail from "@/pages/MarketDetail";
import Trade from "@/pages/Trade";
import Staking from "@/pages/Staking";
import Wallet from "@/pages/Wallet";
import Transactions from "@/pages/Transactions";
import BankAccounts from "@/pages/BankAccounts";
import Subscription from "@/pages/Subscription";
import Admin from "@/pages/Admin";

const RequireAuth = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#A3A9B8]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app/dashboard" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.title = "Orbital — Crypto, EUR · USD · CAD";
  }, []);
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<RequireAuth><AppShell /></RequireAuth>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="markets" element={<Markets />} />
              <Route path="markets/:symbol" element={<MarketDetail />} />
              <Route path="trade" element={<Trade />} />
              <Route path="staking" element={<Staking />} />
              <Route path="wallet" element={<Wallet />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="banks" element={<BankAccounts />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="admin" element={<RequireAuth adminOnly><Admin /></RequireAuth>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
